import React from "react";
import { Calendar, ClockIcon } from "assets/icons";
import Badge from "components/badge/badge";
import { getInterimPdfUrl } from "helper/interimPdfUrl";
import UseContext from "hooks/useContext";
import {
    formatReceivedDate,
    getMonthName,
    parsePayMonth,
    translateEndOfMission,
    translateWithMonth,
} from "pages/content/justificatifs/endOfMissionDocuments/endOfMissionTexts";

const TYPE_FALLBACKS = {
    work_certificate: "Certificat de travail",
    france_travail_certificate: "Attestation France Travail",
};

const RECEIVED_ON_FALLBACKS = {
    work_certificate: "Reçu le {date}",
    france_travail_certificate: "Reçue le {date}",
};

const EndOfMissionDocumentRow = ({ document, onOpen, onShowPending }) => {
    const { language } = UseContext();
    const isAvailable = document.status === "available";
    const isUnopened = isAvailable && !document.openedAt;

    const overline = document.type === "work_certificate"
        ? document.companyName || ""
        : translateEndOfMission(language, "all_missions", "Toutes vos missions");
    const title = translateEndOfMission(language, `types.${document.type}`, TYPE_FALLBACKS[document.type] || "");

    const content = (
        <div className="flex items-start justify-between gap-3 py-4">
            <div className="flex flex-col gap-1 min-w-0">
                {overline && <div className="ft-sm text-gray-500 truncate">{overline}</div>}
                <div className="flex items-center gap-2">
                    {isUnopened && <span className="w-2 h-2 shrink-0 rounded-full bg-yellow-500"/>}
                    <div className="ft-b font-medium text-gray-900">{title}</div>
                </div>
                <div className="flex items-center gap-2 ft-sm text-gray-500">
                    {isAvailable ? (
                        <>
                            <Calendar wh={16} color={"#6B7280"}/>
                            {translateEndOfMission(
                                language,
                                `received_on.${document.type}`,
                                RECEIVED_ON_FALLBACKS[document.type] || "Reçu le {date}",
                                { date: formatReceivedDate(document.availableAt) }
                            )}
                        </>
                    ) : (
                        <>
                            <ClockIcon wh={16} color={"#6B7280"}/>
                            {translateWithMonth(
                                language,
                                "pending_hint",
                                "Avec la fiche de paie de {month}",
                                "Avec la fiche de paie d’{month}",
                                getMonthName(language, parsePayMonth(document.payMonth)?.monthIndex)
                            )}
                        </>
                    )}
                </div>
            </div>
            {!isAvailable && (
                <div className="shrink-0">
                    <Badge type={"WARNING"}>
                        {translateEndOfMission(language, "pending_tag", "En préparation")}
                    </Badge>
                </div>
            )}
        </div>
    );

    if (isAvailable) {
        return (
            <a
                href={getInterimPdfUrl({ type: "endOfMission", id: document._id })}
                target={"_blank"}
                rel="noreferrer"
                onClick={() => onOpen(document._id)}
                className="block cursor-pointer hover:bg-gray-50"
            >
                {content}
            </a>
        );
    }

    return (
        <button
            type="button"
            onClick={() => onShowPending(document)}
            className="block w-full text-left cursor-pointer hover:bg-gray-50"
        >
            {content}
        </button>
    );
};

export default EndOfMissionDocumentRow;
